export const convertPersonCenter = (t: any) => {
	return [{ name: t('member.gerenxinxi'), url: 'personalInformation', id: 1, className: 'personal' }, { name: t('member.jiatingyupengyou'), url: 'familyAndFriends', id: 2, className: 'family' },
		// { name: t('home.wodeyuding'), url: 'orderList', id: 3, className: 'mybooking' }
	];
};
